<script>
import { formatDate } from '../utils/date-helper.js';

export default {
    name: 'CalendarPostsCard',
    props: {
        post: {
            type: Object,
            required: true
        },
        local: {
            type: String,
            default: 'pl-PL'
        }
    },
    computed: {
        formattedDate() {
            return formatDate(this.post.date, this.local);
        }
    }
};
</script>

<template>
    <div
        class="shadow-base rounded-block relative flex max-w-[354px] flex-col bg-white pt-6 pb-8 pr-8 pl-20"
    >
        <div class="absolute top-14 left-4">
            <img class="h-10 w-10" :src="post.icon" :alt="post.title" />
        </div>
        <span class="tracking-tightest mb-2 text-sm">
            {{ formattedDate }}
        </span>
        <a :href="post.url_path" class="text-lg-v2 font-bold">
            {{ post.title }}
        </a>
        <span class="text-sl-v3" v-html="post.content"></span>
    </div>
</template>
